// src/pages/admin/AdminCountries.jsx
import React, { useState, useEffect } from 'react';
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Drawer, DrawerTrigger, DrawerContent } from "../ui/drawer";
import { PlusIcon } from "lucide-react";



import CountryTable from "./CountryTable";
import CountryForm from "./CountryForm";

const API = process.env.REACT_APP_API_BASE;

export default function Countries() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editCountry, setEditCountry] = useState(null);
  const [countries, setCountries] = useState([]);

// ⬇️ Fetch on mount
useEffect(() => {
  fetch(`${API}/api/countries`)
    .then(res => res.json())
    .then(setCountries)
    .catch(err => console.error("Failed to fetch countries", err));
}, []);

  const handleAdd = () => {
    setEditCountry(null);
    setDrawerOpen(true);
  };

  const handleEdit = (country) => {
    setEditCountry(country);
    setDrawerOpen(true);
  };

  return (
    <div className="px-4 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl font-semibold">Existing Countries</h1>
        <Button onClick={handleAdd}>
          <PlusIcon className="w-4 h-4 mr-2" />
          Add Country
        </Button>
      </div>

      <Card>
        <CardContent className="p-0">
        <CountryTable
  countries={countries}
  setCountries={setCountries}
  onEdit={handleEdit}
/>

        </CardContent>
      </Card>

      <Drawer open={drawerOpen} onOpenChange={setDrawerOpen}>
        <DrawerContent>
        <CountryForm
  editCountry={editCountry}
  onClose={() => setDrawerOpen(false)}
  onReload={(updatedList) => setCountries(updatedList)}
/>
        </DrawerContent>
      </Drawer>
    </div>
  );
}
